import { RouteStop } from "@/reducers/routes2gSlice"
import { Element } from "@xmpp/xml"

class DeliveryOrderIdFromCommandResultParser {
  static readonly NAMESPACE = "jabber:x:data"

  static parse(stanza: Element): RouteStop[] | undefined {
    const command = stanza.getChild("command")
    const form = command?.getChild("x", this.NAMESPACE)

    if (!form) {
      return undefined
    }

    const stops = form
      .getChildren("item")
      .map((item) => this.parseItemAsStop(item))
      .filter((stop): stop is RouteStop => stop !== undefined)

    return stops
  }

  static parseDeliverOrderRouteToken(stanza: Element): string | undefined {
    const command = stanza.getChild("command")
    const form = command?.getChild("x", this.NAMESPACE)

    if (!form) {
      return undefined
    }

    // Find the field with var="delivery_order_route_token"
    const fields = form.getChildren("field")
    const tokenField = fields.find(
      (field) => field.getAttr("var") === "delivery_order_route_token",
    )

    if (!tokenField) {
      return undefined
    }

    // Get the value element and return its text content
    const valueElement = tokenField.getChild("value")
    return valueElement?.getText()
  }

  static parseItemAsStop(item: Element): RouteStop | undefined {
    const remainingDistanceRaw = this.getFieldValue(item, "remaining_distance")
    return {
      id: this.getFieldValue(item, "stop_id") || undefined,
      location: {},
      action: this.getFieldValue(item, "action") || undefined,
      remaining_distance:
        remainingDistanceRaw !== null
          ? parseInt(remainingDistanceRaw, 10)
          : undefined,
      deliveryOrderId:
        this.getFieldValue(item, "delivery_order_id") || undefined,
    }
  }

  private static getFieldValue(
    parentElement: Element,
    varName: string,
  ): string | null {
    const field = parentElement.getChildByAttr("var", varName)
    // The value is inside a <value> child of the <field>
    return field?.getChildText("value") ?? null
  }
}

export default DeliveryOrderIdFromCommandResultParser
